import { User } from "@domains/user";

export type UserState = {
    id?: string;
    details?: User;
};

export const INITIAL_STATE: UserState = {};
